common = require '../common'
module.exports = class TestCommon
  move: ->
    # array = [0, 1, 2, 3, 4, 5, 6]
    # common.move array, 4, -2
    
    array = ['zero', 'one', 'two', 'three']
    # common.move array, 1, 2
    common.move array, 'one', 2
    console.log array



